import React, { Component } from 'react';
import { CircularProgress } from '@material-ui/core';
import ResourceIcon from '../components/resources/ResourceIcon';
import { blue, orange, red } from '@material-ui/core/colors';

/**
 * Custom CircularProgress showing resource usage
 */

class MCircularProgress extends Component {
  

  render() {
    const {resource, size} = this.props;
    let limitUsageColor = 'rgba(102,153,153,0.3)';
    let comsumptionColor = limitUsageColor;

    let percent = resource 
      ? 100*resource.value/resource.limit
      : 0;

    percent = percent > 100 ? 100 : percent;
    
    if (percent > 75) 
      comsumptionColor= red[500];
    else if ( percent > 50 )
      comsumptionColor= orange[500];
    else if ( percent > 0 ) 
      comsumptionColor= blue[500]; 
    
    return (
      <div style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center', 
        alignContent: 'center',
        alignItems: 'center',
        width: size,
        height: size,
      }}>
        <CircularProgress 
          style={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position:'absolute', 
            zIndex:1000, 
            color:comsumptionColor
          }}
          variant="static" 
          value={percent} 
          size={size}/>
        <CircularProgress 
          style={{ 
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position:'absolute',
            color:limitUsageColor
          }}
          variant="static" 
          value={100} 
          size={size}/>  
        {
          resource.id==='licence'?
            null
          :
            <ResourceIcon 
              style={{
                color: comsumptionColor
              }}
              resource={resource}
              />
        }
      </div>
      
    );
  }  
}

export default MCircularProgress;


// WEBPACK FOOTER //
// ./src/components/CircularProgress.js